// extracted by mini-css-extract-plugin
export default {"globalMetaTable":"meta-tables_globalMetaTable__zfk4H"};